import { branchPlatform as bp, noop, promisify } from './util'

const ss = cordova.plugins.SecureKeyStore

export default {
  get (provider) {
    return bp({
      browser: noop,
      native: async () => {
        const get = promisify(ss.get.bind(ss), 0)

        if (provider === 'ridi') {
          const [id, password] = await Promise.all([
            get('ridi_id'),
            get('ridi_password')
          ])
          return { id, password }
        }

        if (provider === 'millie') {
          const [id, password] = await Promise.all([
            get('millie_id'),
            get('millie_password')
          ])
          return { id, password }
        }
      }
    })
  },
  set (provider, auth) {
    return bp({
      browser: noop,
      native: () => {
        const set = promisify(ss.set.bind(ss), 0)

        if (provider === 'ridi') {
          return Promise.all([
            set('ridi_id', auth.id),
            set('ridi_password', auth.password)
          ])
        }

        if (provider === 'millie') {
          return Promise.all([
            set('millie_id', auth.id),
            set('millie_password', auth.password)
          ])
        }
      }
    })
  },
  clear () {
    return bp({
      browser: noop,
      native: () => {
        const remove = promisify(ss.remove.bind(ss), 0)

        return Promise.all([
          remove('ridi_id'),
          remove('ridi_password'),
          remove('millie_id'),
          remove('millie_password')
        ])
      }
    })
  }
}
